/**
 * Temporary auth behaviour switches (2026-10-01). Each is a one-line revert.
 */

/**
 * Google sign-in is hidden on the sign-in and sign-up pages. The OAuth callback
 * route and `authService.signInWithGoogle` stay in place so existing Google
 * sessions keep working; flip to `true` to restore the button.
 */
export const googleSignInEnabled = false;

/**
 * Whether sign-out first checks the learner's workspace, waits for running
 * operations and saves the open IDE. While `false`, sign-out ends the session
 * immediately; the workspace keeps its last checkpoint and is paused by the
 * usual idle maintenance. The guards, blocked-sign-out messages and "Sign out
 * anyway" path stay wired so `true` restores the full preparation flow.
 */
export const workspacePreparationOnSignOut = false;
